import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, style, animate, transition, keyframes, state, query} from '@angular/animations';
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";
import {ActivatedRoute, Router} from "@angular/router";

declare var $ :any;

@Component({
  selector: 'app-case-practice-authorization-question',
  animations:[
    trigger('answerShowAnimation', [
      transition('void => *', animate('300ms', keyframes([
      	style({opacity: 0, transform: 'scale(.3)',offset:0}),
        style({opacity: 1, transform: 'scale(1.3)',offset:0.8}),
        style({opacity: 1, transform: 'scale(1)',offset:1})
      ]))),
    ]),
    trigger('tellWrapAnimation', [
      state('showTellWrap', style({opacity: 1,display:""})),
      state('hideTellWrap', style({opacity: 0,display:"none"})),
      transition('hideTellWrap => showTellWrap', [
        animate('500ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ])),
        // query('#tellBtn', animate('500ms', keyframes([
        //   style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        //   style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        //   style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        //   style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        //   style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        //   style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        //   style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        //   style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        //   style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        //   style({transform: 'scale(1, 1)', opacity: 1})
        // ])))
      ]),
    ])

  ],
  templateUrl: './case-practice-authorization-question.component.html',
  styleUrls: ['./case-practice-authorization-question.component.css']
})
export class CasePracticeAuthorizationQuestionComponent implements OnInit, AfterViewInit {
    @Input() exerciseId:number;
    @Input() practiceId:number;
    @Input() practiceMetaId:number;
    @Input() learningPathId:number;
    @Input() exerciseMetaId:number;
    @Input() type:string
    questions: any;
    currentQuestion: string;
    currentOption: string;
    currentRightAnswer:string;
    questionBtnMode: number;
    showAnswer: boolean;
    selectedAble: boolean;
    currentQuestionNumber: number;
    tell: string

    completedQuestions: any;

    tellWrapShow: boolean;

    taskBook: any;
  assetsRoute: string = "../../assets";

  constructor(
      private commonService:CommonService,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private router: Router
  ) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.apiService.ajax({

      'type':'get',
      'url':'/api/taskBook/'+this.exerciseId

    }).subscribe(result=>{

      this.taskBook = result;

    });

  }

  ngAfterViewInit(){
      this.commonService.initPage({
          'backgroundColor':'white'
      });

      this.questionInit();
  }

  questionInit(){
      this.apiService.ajax({
          'type': 'get',
          'url': '/api/authQuestion/'+this.exerciseId
      }).subscribe(result=>{
          this.tell = result.concatenation;
          this.questions = result.questions;
          this.completedQuestions = result.completed;
          this.currentOption = '';
          if(this.completedQuestions.length<this.questions.length){
              this.tellWrapShow = false;
              this.currentQuestionNumber = this.completedQuestions.length;
              this.currentQuestion = this.questions[this.currentQuestionNumber].title;
              this.currentRightAnswer = this.questions[this.currentQuestionNumber].answer;
              this.questionBtnMode = 1;
              this.showAnswer = false;
              this.selectedAble = true;
          }else{
              this.tellWrapShow = true;
          }
      });
  }

  onOptionClick(i){
      if(!this.selectedAble){
          return;
      }
      if(i==0){
          this.currentOption = '要交代';
      }else{
          this.currentOption = '不该说';
      }
  }

  onQuestionBtnClick(){
      if(this.currentOption==''){
          return;
      }
      if(this.questionBtnMode == 1){
          if(this.currentQuestionNumber < this.questions.length-1){
              this.questionBtnMode = 2;
          }else{
              this.questionBtnMode = 3;
          }
          this.showAnswer = true;
          this.selectedAble = false;
          this.apiService.ajax({
              'type': 'post',
              'url':'/api/authQuestion/'+this.exerciseId,
              'data':{
                  'authquestion_id':this.questions[this.currentQuestionNumber].id,
                  'isTrue': this.currentOption == this.currentRightAnswer ? 1:2
              }
          }).subscribe(result=>{

          });
      }else if(this.questionBtnMode == 2){
          this.currentOption = '';
          this.currentQuestionNumber++;
          this.currentQuestion = this.questions[this.currentQuestionNumber].title;
          this.currentRightAnswer = this.questions[this.currentQuestionNumber].answer;
          this.questionBtnMode = 1;
          this.showAnswer = false;
          this.selectedAble = true;
      }else if(this.questionBtnMode == 3){
          /*$('#questionWrap').fadeOut(200);
          setTimeout(function () {
              $('#tellWrap').fadeIn(200);
          },500);*/

          this.tellWrapShow = true;
      }
  }

  taskBookOut($event){
      $event.stopPropagation();
      $('#shade').fadeIn(50);
      $('#taskBookBox').fadeIn();
      $('#closeBtn').fadeIn();
  }

  closeTip($event){

      $event.stopPropagation();
      $('#shade').fadeOut();
      $('#taskBookBox').fadeOut();
      $('#closeBtn').fadeOut();
      // 恢复点击功能
  }

    goToMain(){
      this.commonService.setOnceIno(this.commonService.getOnceValue(this.exerciseMetaId,704)).subscribe();
      let link = ['case-practice-authorization-main',this.learningPathId,this.practiceId,this.exerciseId];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
      }else{
        this.router.navigate(link);
      }
    
    }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-question/case-practice-authorization-question.component.ts